import Home from "@/components/home/Home";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";
import { fetchGraphql } from "@/utils/query";

export default function GovPage({ type }) {
    return isProspect(type) ? <Home redirectToHome={true} /> : <NotFound />;
}

export async function getServerSideProps() {
    const result = await fetchGraphql(
        `mutation {
            increasePageViewCount(url: "/gov")
        }`
    );

    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}
